export const LANDING_PAGES_REPORT_ID = 'landing-pages';
